module.exports = "https://coursera_assets.s3.amazonaws.com/images/46a91ef80331a08ae3532814b18e2046.jpg";